import { useNavigate } from "react-router-dom";
import url from "url/index";
import { SEO } from "utils/helmet/components/SEO";
import NotificationListMobileContainer from "containers/molecules/NotificationListMobileContainer";
import useTranslate from "hooks/useTranslate";

import ArrowBackIcon from "assets/icons/glory/arrow-back.svg?react";

import "./styles.sass";

const NotificationPage = () => {
  const navigate = useNavigate();
  const t = useTranslate();

  return (
    <>
      <SEO
        pathname={`/${url.config.profile.root}/${url.config.profile.notification}`}
      />
      <div className="NotificationPage">
        <div onClick={() => navigate(-1)} className="NotificationPage-header">
          <ArrowBackIcon />
          <div className="NotificationPage-header__title">
            {t("notification.page.notification")}
          </div>
        </div>
        <div className="NotificationPage__content">
          <NotificationListMobileContainer />
        </div>
      </div>
    </>
  );
};

export default NotificationPage;
